const pre = '/bcos/';

export default {
    path: '/bcos/app',
    title: '应用管理',
    header: '',
    icon: 'md-apps',
}